module.exports = __webpack_public_path__ + "static/img/Bachelor_010751.ce1e4e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010751.jpg
// module id = 242
// module chunks = 0